// DashboardSalesGraph.js
import React, { useState } from "react";
import SalesGraphCore from "../../../../components/charts/SalesGraphCore";

export default function DashboardSalesGraph({
  salesData,
  isLoading,
  interval = "weekly",
}) {
  const [metric, setMetric] = useState("revenue");

  if (!salesData?.forecast_graph) {
    return <div className="h-full" />;
  }

  return (
    <div className="h-full flex flex-col">
      <div className="flex justify-end mb-3">
        <div className="flex rounded-full border border-white/20 overflow-hidden">
          {["revenue", "profit"].map((m) => (
            <button
              key={m}
              onClick={() => setMetric(m)}
              className={`px-4 py-1.5 text-sm ${
                metric === m
                  ? "bg-yellow-300 text-black"
                  : "text-white/70 hover:bg-white/10"
              }`}
            >
              {m === "revenue" ? "Revenue" : "Profit"}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1 min-h-0">
        <SalesGraphCore
          salesData={salesData}
          isLoading={isLoading}
          interval={interval}
          metric={metric}
        />
      </div>
    </div>
  );
}